module.exports = __webpack_public_path__ + "img/hiper.b93e9b6f.svg";